export default __webpack_public_path__ + "static/media/logo.3cec99f9.png";